import React, { useState } from 'react';
import cn from 'classnames';
import { Collapse } from 'reactstrap';
import { oneOfType, array, object, string, number } from 'prop-types';
import { ContractRenderer } from '../Contracts/ContractRenderers';

const Accordion = ({ items, collapsedIndex }) => {
  const [collapse, setCollapse] = useState(collapsedIndex);

  const toggle = (index) => {
    setCollapse(collapse === index ? null : index);
  };

  const getCardsItems = () => {
    if (typeof items === 'object') {
      return Object.keys(items).map((key) => items[key]);
    } else {
      return items;
    }
  };

  const renderContent = (item) => {
    if (item.type) {
      return <ContractRenderer type={item.type} data={item} getLabelId={item.getLabelId} />;
    }

    return item.body;
  };

  return (
    <div className="accordion">
      {getCardsItems().map((item, index) => (
        <div
          key={index}
          className={cn('contracts-card', item.cardClassName, { isOpen: collapse === index })}
        >
          <div className="contracts-card-header" onClick={() => toggle(index)}>
            <span className="contracts-card-header-title">{item.header}</span>
          </div>
          <Collapse isOpen={collapse === index}>
            <div className="contracts-card-body">{renderContent(item)}</div>
          </Collapse>
        </div>
      ))}
    </div>
  );
};

Accordion.propTypes = {
  items: oneOfType([array, object]),
  collapsedIndex: oneOfType([string, number]),
};

Accordion.defaultProps = {
  items: [],
  collapsedIndex: null,
};

export default Accordion;
